/**
 * Reads `response.status` off any error shape — axios-wrapped or a plain object — without requiring
 * `isAxiosError`, so a rejection thrown by a test double or by a non-axios layer classifies the same
 * way a real one does.
 *
 * Returns `undefined` when there is no `response` at all (a network failure, a bare `Error`) AND
 * when the `response` carries no `status`: nothing is known about the HTTP outcome in either case,
 * so callers must not read that as a status they can branch on.
 *
 * Here rather than beside `getApiErrorCode` in `infrastructure/services/ApiErrorService.ts`: that
 * module top-level-imports `@/plugins/i18n`, which consumers of a pure shape check must not have to
 * pull into their unit tests.
 */
export function getApiErrorStatus(e) {
    if (e !== null && typeof e === "object" && "response" in e) {
        const response = e.response;
        if (response !== null && typeof response === "object" && "status" in response) {
            return response.status;
        }
    }
    return undefined;
}
